import { type PropsWithChildren } from "react";

export function ScreenMenuControlGroup({ children }: PropsWithChildren) {
  return <div className="relative w-2/3 p-8 mb-16">{children}</div>;
}
